import React from 'react';
import styled from 'styled-components';
import ThemeContext from '../Theme/ThemeContext';

const Container = styled.div`
    color: ${props => props.contrastcolor};
    text-align: left;
    padding-top: 10px;
    max-width: 250px;
    white-space: break-spaces;
`;

const VirtualContainer = styled.div`
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0px;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.54);
`;

const StartEndTime = props => {
    const StartEndTimeWrapper = props.isVirtual ? VirtualContainer : Container;
    return (
        <ThemeContext.Consumer>
            {({ theme }) => (
                <StartEndTimeWrapper contrastcolor={theme.contrast}>
                    {props.text}
                </StartEndTimeWrapper>
            )}
        </ThemeContext.Consumer>
    );
};

export default StartEndTime;
